export default __webpack_public_path__ + "static/media/Group-7511.78733baf.png";